export function pageLayout(newDevice) {
  const device = newDevice || getCurrentDevice();
  const BODY_SELECTOR = window.getComputedStyle(document.body),
    HEADER_POSITION =
      BODY_SELECTOR.getPropertyValue('--cm4all-theme-header-position').trim() ||
      'absolute',
    LOGO_WIDTH_CUSTOMIZER =
      BODY_SELECTOR.getPropertyValue('--cm4all-theme-logo-size').trim() || 100,
    HEADER_WIDTH =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-desktop-navigation-width'
      ).trim() || 'full-width',
    NAVIGATION_TYPE =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-navigation-hamburger-display'
      ).trim() || 'none',
    NAVIGATION_VISIBILITY =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-navigation-visibility'
      ).trim() || 'visible',
    NAVIGATION_VISIBLE =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-navigation-visible'
      ).trim() || 'none',
    HEADER_DISPLAY =
      BODY_SELECTOR.getPropertyValue('--cm4all-theme-header-display').trim() ||
      'none',
    NAVIGATION_SCROLL =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-navigation-scrolling'
      ).trim() || 'sticky',
    GROUP_HEADER_AND_NAVIGATION =
      BODY_SELECTOR.getPropertyValue(
        '--cm4all-theme-group-logo-and-navigation'
      ).trim() || 'yes',
    THEME_HEADER = document.querySelector('.cm4all-theme-header'),
    MENU_PRESETS =
      BODY_SELECTOR.getPropertyValue(
        `--cm4all-theme-${device}-logo-navigation-presets`
      ).trim() || 'logo-left-navigation-right';

  /** Split navigation main  */
  const MENU_UL = document.querySelectorAll(
      '.cm4all-theme-navigation-main__menu > ul'
    ),
    MENU_LI = document.querySelectorAll(
      '.cm4all-theme-navigation-main__menu > ul > li'
    ),
    LOGO = document.querySelector(
      '.cm4all-theme-header-container .custom-logo'
    );
  if (LOGO && LOGO.src) {
    if (
      (MENU_PRESETS === 'logo-center-navigtaion-split' ||
        MENU_PRESETS === 'logo-center-navigtaion-split-ote') &&
      MENU_UL.length === 1
    ) {
      if (MENU_LI.length) {
        const MENU_FIRST = document.createElement('ul'),
          MENU_LOGO = document.createElement('div'),
          MENU_SECOND = document.createElement('ul'),
          MENU_OLD = [...MENU_UL];

        MENU_FIRST.classList.add('split-menu-first');
        MENU_LOGO.classList.add('split-menu-logo');
        MENU_SECOND.classList.add('split-menu-second');
        MENU_OLD[0].parentNode.removeChild(MENU_OLD[0]);
        for (let i = 0; i < Math.ceil(MENU_LI.length / 2); i++) {
          MENU_FIRST.innerHTML += MENU_LI[i].outerHTML;
        }
        for (let i = Math.ceil(MENU_LI.length / 2); i < MENU_LI.length; i++) {
          MENU_SECOND.innerHTML += MENU_LI[i].outerHTML;
        }
        const LOGO_OLD = document.querySelector(
          '.cm4all-theme-logo-navigation-group > .cm4all-theme-logo-main'
        );
        MENU_LOGO.innerHTML = LOGO_OLD.innerHTML;
        LOGO_OLD.parentNode.removeChild(LOGO_OLD);
        const APPEND_CHILD = [MENU_FIRST, MENU_LOGO, MENU_SECOND],
          NAV_MENU = document.querySelector(
            '.cm4all-theme-navigation-main > nav'
          );
        for (const appends of APPEND_CHILD) {
          NAV_MENU.appendChild(appends);
        }
      }
    } else if (
      /** check is menu split */
      MENU_PRESETS !== 'logo-center-navigtaion-split' &&
      MENU_PRESETS !== 'logo-center-navigtaion-split-ote' &&
      MENU_UL.length > 1
    ) {
      const MENU_LOGO = document.createElement('div'),
        MENU = document.createElement('ul'),
        MENU_OLD = document.querySelectorAll(
          '.cm4all-theme-navigation-main > nav > ul'
        ),
        MENU_LOGO_OLD = document.querySelector('.split-menu-logo > a'),
        MENU_LOGO_OLD_CONTAINER = document.querySelector('.split-menu-logo'),
        MENU_CONTAINER = document.querySelector(
          '.cm4all-theme-logo-navigation-group'
        );

      /* add the li from the first level in the new ul  */
      const SPLIT_MENUS = ['split-menu-first', 'split-menu-second'];

      for (const classnames of SPLIT_MENUS) {
        for (const li of document.querySelectorAll(
          '.' + classnames + ' > li'
        )) {
          MENU.innerHTML += li.outerHTML;
        }
      }

      MENU_LOGO.classList.add('cm4all-theme-logo-main');
      MENU_LOGO.appendChild(MENU_LOGO_OLD);
      MENU_CONTAINER.insertBefore(MENU_LOGO, MENU_CONTAINER.firstChild);
      MENU.setAttribute('id', 'menu-main-menu');

      for (const removeUL of MENU_OLD) {
        removeUL.parentNode.removeChild(removeUL);
      }
      MENU_LOGO_OLD_CONTAINER.parentNode.removeChild(MENU_LOGO_OLD_CONTAINER);
      document
        .querySelector('.cm4all-theme-navigation-main > nav')
        .appendChild(MENU);
    }

    const LOGO_WRAPPER = document.querySelector(
        '.cm4all-theme-header-container .cm4all-theme-logo-main'
      ),
      LOGO_WRAPPER_SPLIT = document.querySelector(
        '.cm4all-theme-header-container .split-menu-logo'
      );
    /** resize Logo its now only for customizer */
    if (LOGO_WRAPPER) {
      LOGO_WRAPPER.style.width =
        (LOGO_WIDTH_CUSTOMIZER / 100) * parseInt(LOGO.attributes.width.value) +
        'px';
      LOGO_WRAPPER.style.maxHeight =
        (LOGO_WIDTH_CUSTOMIZER / 100) * parseInt(LOGO.attributes.height.value) +
        'px';
    }
    if (LOGO_WRAPPER_SPLIT) {
      LOGO_WRAPPER_SPLIT.style.width =
        (LOGO_WIDTH_CUSTOMIZER / 100) * parseInt(LOGO.attributes.width.value) +
        'px';
      LOGO_WRAPPER_SPLIT.style.maxHeight =
        (LOGO_WIDTH_CUSTOMIZER / 100) * parseInt(LOGO.attributes.height.value) +
        'px';
    }
  }

  /**
   *  Set homepage as active only by onepager if user scroll to top
   *
   * @param {Object} onepagerStartItem a list of onepager start anker
   */

  const checkIfPageOnTop = (onepagerStartItem) => {
    window.addEventListener('scroll', function () {
      const topPosition = document.documentElement.scrollTop
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
      if (topPosition === 0) {
        for (const setActive of onepagerStartItem) {
          for (const activeLevelAnker of setActive.parentElement.parentElement
            .children) {
            activeLevelAnker.classList.remove('current-menu-item');
          }
          setActive.parentElement.classList.add('current-menu-item');
        }
      }
    });
  };

  const CURRENT_PAGE_ITEM = document.querySelectorAll(
    '.cm4all-theme-header ul > li.current-menu-item'
  );

  if (CURRENT_PAGE_ITEM && CURRENT_PAGE_ITEM.length > 2) {
    const onePagerStartItems = [];
    for (const removeCurrentPage of CURRENT_PAGE_ITEM) {
      for (const child of removeCurrentPage.children) {
        if (child.tagName === 'A') {
          if (child.hash) {
            removeCurrentPage.classList.remove('current-menu-item');
          } else {
            onePagerStartItems.push(child);
            child.addEventListener('click', function (e) {
              e.preventDefault();
              const URI = window.location.toString();
              if (URI.indexOf('#') > 0) {
                const CLEAN_URI = URI.substring(0, URI.indexOf('#'));
                window.history.replaceState({}, document.title, CLEAN_URI);
              }
              window.scrollTo(0, 0);
            });
          }
        }
      }
    }
    checkIfPageOnTop(onePagerStartItems);
  }

  if (
    document.querySelectorAll('.cm4all-theme-navigation-mobile-drawer--open')
  ) {
    const CLICK_HAMBURGER_ANCHOR = document.querySelectorAll(
      '.cm4all-theme-navigation-mobile-drawer__menu li > a'
    );
    for (const CLICK_HAMBURGER of CLICK_HAMBURGER_ANCHOR) {
      CLICK_HAMBURGER.addEventListener('click', function () {
        document
          .querySelectorAll(
            '.cm4all-theme-hamburger.cm4all-theme-js-hamburger.cm4all-theme-hamburger--collapse.cm4all-theme-hamburger--active'
          )[0]
          .click();
      });
    }
  }
  const FIRST_LEVEL_ANCHORS = document.querySelectorAll('nav > ul > li a');

  // intersectionObserver callback --> fires after section is visible
  const setMenuActive = (entries) => {
    for (const ENTRY of entries) {
      if (ENTRY.isIntersecting) {
        const ANCHOR_COPY = [...FIRST_LEVEL_ANCHORS];
        for (const ANCHOR of FIRST_LEVEL_ANCHORS) {
          if (!!ANCHOR.parentElement.classList.contains('current-menu-item')) {
            ANCHOR.parentElement.classList.remove('current-menu-item');
          }
        }
        const ACTIVE_ANCHORS = ANCHOR_COPY.filter(
          (_) => _?.hash.replaceAll('#', '') === ENTRY?.target?.id
        );
        for (const ACTIVE_ANCHOR of ACTIVE_ANCHORS) {
          ACTIVE_ANCHOR.parentElement.classList.add('current-menu-item');
        }
      }
    }
  };

  // creating new instance of intersectionObsever
  const ONEPAGER_OBSERVER = new IntersectionObserver(setMenuActive, {
    root: null,
    rootMargin: '0px',
    threshold: 0.7,
  });

  // rule for triggering observer
  for (const SECTION_SELECTOR of FIRST_LEVEL_ANCHORS) {
    if (SECTION_SELECTOR?.hash) {
      let SECTION_ELM;
      try {
        SECTION_ELM = document.querySelector(SECTION_SELECTOR.hash);
      } catch (e) {}
      if (!!SECTION_ELM) {
        ONEPAGER_OBSERVER.observe(SECTION_ELM);
      }
    }
  }

  /** ONEPAGE eof  */

  function checkMainContentPosition(MAIN_CONTENT_TOP_POSITION, MAIN_HEADER) {
    if (window.scrollY >= MAIN_CONTENT_TOP_POSITION) {
      MAIN_HEADER.classList.add('scrolltrigger');
    } else {
      MAIN_HEADER.classList.remove('scrolltrigger');
    }
  }

  const MAIN_HEADER = document.querySelectorAll('header:first-child')[0],
    MAIN_CONTENT = document.getElementsByClassName('cm4all-theme-content')[0],
    HEADER_HEIGHT = MAIN_HEADER.offsetHeight,
    MAIN_CONTENT_TOP_POSITION = HEADER_HEIGHT <= 104 ? 80 : HEADER_HEIGHT;

  if (
    (NAVIGATION_VISIBLE === 'flex' || HEADER_DISPLAY === 'flex') &&
    NAVIGATION_SCROLL === 'sticky' &&
    HEADER_POSITION === 'sticky'
  ) {
    MAIN_CONTENT.style.marginTop = MAIN_CONTENT_TOP_POSITION + 'px';
  } else {
    MAIN_CONTENT.style.marginTop = '0';

    window.onscroll = function () {
      checkMainContentPosition(MAIN_CONTENT_TOP_POSITION, MAIN_HEADER);
    };
  }

  /* check if last navigation points submenue over the right side function print eof */
  addClassOnRightSubmenu();

  switch (typeof window.parent.wpWidgets) {
    case 'undefined':
      THEME_HEADER.classList.replace(
        `cm4all-theme-header-position--${
          HEADER_POSITION === 'absolute' ? 'sticky' : 'absolute'
        }`,
        `cm4all-theme-header-position--${HEADER_POSITION}`
      );
      THEME_HEADER.classList.replace(
        `cm4all-theme-header--${
          HEADER_WIDTH === 'full-width' ? 'wide-width' : 'full-width'
        }`,
        `cm4all-theme-header--${HEADER_WIDTH}`
      );
      THEME_HEADER.classList.replace(
        `cm4all-theme-navigation-hamburger-display--${
          NAVIGATION_TYPE === 'none' ? 'flex' : 'none'
        }`,
        `cm4all-theme-navigation-hamburger-display--${NAVIGATION_TYPE}`
      );
      THEME_HEADER.classList.replace(
        `cm4all-theme-navigation-visibility--${
          NAVIGATION_VISIBILITY === 'visible' ? 'hidden' : 'visible'
        }`,
        `cm4all-theme-navigation-visibility--${NAVIGATION_VISIBILITY}`
      );

      THEME_HEADER.classList.replace(
        `cm4all-theme-navigation-scrolling--${
          NAVIGATION_SCROLL === 'sticky' ? 'scroll' : 'sticky'
        }`,
        `cm4all-theme-navigation-scrolling--${NAVIGATION_SCROLL}`
      );

      THEME_HEADER.classList.replace(
        `cm4all-theme-group-logo-and-navigation--${
          GROUP_HEADER_AND_NAVIGATION === 'yes' ? 'no' : 'yes'
        }`,
        `cm4all-theme-group-logo-and-navigation--${GROUP_HEADER_AND_NAVIGATION}`
      );
      break;
  }
}

export function getCurrentDevice() {
  const devices = [
    {
      name: 'desktop',
      viewportMin: 1025,
      viewportMax: 6000,
    },
    {
      name: 'tablet-landscape',
      viewportMin: 768,
      viewportMax: 1024,
    },
    {
      name: 'tablet',
      viewportMin: 576,
      viewportMax: 767,
    },
    {
      name: 'mobile',
      viewportMin: 1,
      viewportMax: 575,
    },
  ];
  const width = window.innerWidth;

  for (const device of devices) {
    if (width >= device.viewportMin && width <= device.viewportMax) {
      return device.name;
    }
  }
}

function addClassOnRightSubmenu() {
  const SUB_MENUES = document.querySelectorAll(
    '.cm4all-theme-navigation-main__menu > ul > li > .sub-menu'
  );
  for (const SUB_MENU of SUB_MENUES) {
    SUB_MENU.classList.remove('cm4all-theme-navigation__sub-menu--left');
    if (window.innerWidth - SUB_MENU.getBoundingClientRect().right < 0) {
      SUB_MENU.classList.add('cm4all-theme-navigation__sub-menu--left');
    }
  }

  /**
   * float last submenu third level left when it goes over the edge
   */

  const LAST_SUBMENUS = document.querySelectorAll(
    '.cm4all-theme-navigation-main__menu > ul > li > .sub-menu .sub-menu'
  );
  for (const LAST_SUBMENU of LAST_SUBMENUS) {
    if (window.innerWidth - LAST_SUBMENU.getBoundingClientRect().right < 0) {
      LAST_SUBMENU.classList.add('float-left');
    }
  }
}

let RESIZE_END;
function onEndResize() {
  addClassOnRightSubmenu();
  pageLayout();
}
window.onresize = function () {
  clearTimeout(RESIZE_END);
  RESIZE_END = setTimeout(function () {
    onEndResize();
  }, 200);
};

document.documentElement.addEventListener(
  'cm4all-theme-settings',
  () /*event*/ => {
    // const val = event.detail['Global Page Settings']['page-layout'];
    pageLayout();
  }
);
